import React, { Component } from 'react';

import { Col, Row } from 'reactstrap';
import graphLogo from '../../../../public/img/GARP_logo.png';
import notesIcon from '../../../../public/img/notes/notes_icon1.svg';
import ChapterCard from '../../../Components-2025/QuestionBank/ChapterCards';
import LoaderWrapper from '../../../Components-2025/QuestionBank/LoaderWrapper';
import ComponentHeader from '../../../common/ComponentHeader';
import CustomButton from '../../../common/CustomButton';
import { openPDF } from '../../../common/function';
import { messages } from '../../../common/messages';
import { showInformation } from '../../../common/toast';
import ModalComponent from '../../Common/Modal';
import appRoutes from '../../config/AppRoutes';
import alertMessage from '../../config/alertMessage';
import {
  chapterIdKey,
  chapterNameKay,
  readingIdKey,
  tableChapterKey,
  tableKey,
  totalNotesKey,
} from './ApiAttributesKays';
import apiServiceProvider from './ApiService';

export class Notes extends Component {
  static contextTypes = { router: React.PropTypes.object };
  constructor(props) {
    super(props);
    this.state = {
      chapterId: '',
      questionId: '',
      isLoading: true,
      isButtonDisablePart1: false,
      isButtonDisablePart2: false,
      isUserSubscribedBoth: false,
      isUserSubscribedPart1: false,
      isUserSubscribedPart2: false,
      openPremiumPopup: false,
      chapterDataPart1: [],
      chapterDataPart2: [],
      selectedExamSubscriptionDetails: {},
    };
  }
  //* ============================{{ COMPONENT DID MOUNT START HERE }}========================================
  componentDidMount = async () => {
    const {
      location: { state },
    } = this.props;
    if (!(state && state.chapterDataPart1 && state.chapterDataPart2)) {
      this.getChapterWiseCount({ level: 1 });
      this.getChapterWiseCount({ level: 2 });
    } else {
      this.setState({ ...state, isLoading: false });
    }
  };
  //* ============================{{ COMPONENT DID MOUNT ENDED HERE }}==========================================

  //* ==================={{ PREMIUM REDIRECTION FUNCTION AND MODAL TOGGLE ENDED HERE }}=========================

  //* ====================={{ CHAPTER COUNT CARD  START HERE }}=============================
  getChapterWiseCount = async level => {
    const result = await apiServiceProvider['fetchChaptersWithPremiumAndFreeCount'](level);
    if (result.success) {
      this.setState({
        isLoading: false,
        [`chapterDataPart${level.level}`]: result.data,
        [`isUserSubscribedPart${level.level}`]:
          result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${level.level}`] &&
          result.selectedExamSubscriptionDetails[`subscriptionDetailsForFrm${level.level}`].noteStatus,
        isUserSubscribedBoth:
          result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2 &&
          result.selectedExamSubscriptionDetails.subscriptionDetailsForFrm1And2.noteStatus,
      });
    }
    this.setState({ isLoading: false });
  };

  //* ====================={{ CHAPTER COUNT CARD ENDED HERE }}=============================

  //* ============================{{ REDIRECTION FUNCTION START HERE }}========================================
  redirectToLastNoteRead = async level => {
    this.setState({ [`isButtonDisablePart${level.level}`]: true });
    const result = await apiServiceProvider['fetchLastNoteRead'](level);
    this.setState({ [`isButtonDisablePart${level.level}`]: false });

    //* FIRST OF ALL CHECK THE REDIRECTION
    if (result.success) {
      const { data } = result;
      const { router } = this.context;
      router.push({
        pathname: appRoutes.FRM_V2_NOTES_VIEW.replace(':level', level.level)
          .replace(':readingId', data[tableKey][readingIdKey])
          .replace(':questionId', data[tableKey].id)
          .replace(':chapterId', data[tableKey][tableChapterKey]),
      });
    } else {
      showInformation(messages.NOTES_NOT_AVAILABLE);
    }
  };
  //* ============================{{ REDIRECTION FUNCTION ENDED HERE }}========================================

  goPremium = () => {
    const { router } = this.context;
    router.push({ pathname: '/Subscribe' });
  };
  toggleAlert = () => {
    this.setState({ openPremiumPopup: !this.state.openPremiumPopup });
  };
  render() {
    const { state, context } = this;
    const {
      imageWidth,
      isLoading,
      isUserSubscribedBoth,
      openPremiumPopup,
      chapterDataPart1,
      chapterDataPart2,
    } = state;
    const { router } = context;

    return (
      <div className='animated fadeIn'>
        <ComponentHeader title={messages.NOTES} className='frm_title_logo_wrap'>
          <img
            src={graphLogo}
            className='garpLogo'
            alt='full logo'
          />
        </ComponentHeader>

        {/*//*================================================={{ PART I AND II START HERE }}================================================  */}
        {['1', '2'].map(level => (
          <div key={level}>
            <ComponentHeader title={messages[`FRM_TOPIC_PART_${level}`]}>
              <CustomButton
                className='bg-completed-cases overflow-hidden max-width-min-content ml-auto'
                onClick={() => {
                  isUserSubscribedBoth || state[`isUserSubscribedPart${level}`]
                    ? apiServiceProvider['downloadFormulaSheet']({
                        type: 'Formula sheet',
                        level,
                      }).then(res => openPDF(res))
                    : this.toggleAlert();
                }}
              >
                <i className='fa fa-download pr-1' aria-hidden='true' />
                {!(isUserSubscribedBoth || state[`isUserSubscribedPart${level}`]) && (
                  <div className='premium-download'>Premium</div>
                )}
                {messages.FORMULA_SHEET}
              </CustomButton>
              <button
                className='btn btn-primary pointer_class'
                onClick={() => this.redirectToLastNoteRead({ level })}
                disabled={state[`isButtonDisablePart${level}`]}
              >
                {state[`isButtonDisablePart${level}`] && (
                  <i className='fa fa-spinner fa-spin mr-1' />
                )}
                {messages.GO_TO_MY_LAST_READ_NOTE}
              </button>
            </ComponentHeader>
            <LoaderWrapper isLoading={isLoading}>
              <Row>
                <Col className='seperator-block-wrap'>
                  <div className='card'>
                    <div className='card-block'>
                      <Row>
                        {state[`chapterDataPart${level}`].length &&
                          state[`chapterDataPart${level}`].map((item, index) => {
                            return (
                              <ChapterCard
                                onClick={() =>
                                  isUserSubscribedBoth ||
                                  state[`isUserSubscribedPart${level}`] ||
                                  index === 0
                                    ? router.push({
                                        pathname: appRoutes.FRM_V2_NOTES_READING_LIST.replace(
                                          ':level',
                                          level,
                                        ).replace(':chapterId', item[chapterIdKey]),
                                        state: { chapterDataPart1, chapterDataPart2 },
                                      })
                                    : this.toggleAlert()
                                }
                                key={item[chapterIdKey]}
                                headerImage={notesIcon}
                                headerImageWidth={imageWidth}
                                chapterNumber={item[chapterIdKey]}
                                chapterName={item[chapterNameKay]}
                                totalNotes={item[totalNotesKey]}
                                userSubscriptionDetails={
                                  isUserSubscribedBoth || state[`isUserSubscribedPart${level}`]
                                }
                                callingComponent='notes'
                                free={index === 0}
                                {...this.props}
                              />
                            );
                          })}
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </LoaderWrapper>
          </div>
        ))}
        {/* //* THIS IS FOR PREMIUM POPUP  */}
        <ModalComponent
          goPremium={this.goPremium}
          toggleAlert={this.toggleAlert}
          alert_status={openPremiumPopup}
          MessageContent={alertMessage.messageContent_frm}
        />
        {/*//*================================================={{ PART I AND II ENDED HERE }}================================================  */}
      </div>
    );
  }
}

export default Notes;



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/index.jsx